import React from 'react';
import { motion } from 'framer-motion';

interface Integration {
  title: string;
  description: string;
}

interface IntegrationSectionProps {
  integrations: Integration[];
}

const IntegrationSection: React.FC<IntegrationSectionProps> = ({ integrations }) => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold mb-8">Seamless Integration</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Works with your existing healthcare systems
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {integrations.map((integration, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              className="bg-gray-50 p-8 rounded-2xl"
            >
              <h3 className="text-xl font-bold mb-4">{integration.title}</h3>
              <p className="text-gray-600">{integration.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IntegrationSection;